var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinMarkerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 105,
    viewBox: "0 0 80 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.0928,
    r: 40,
    fill: "#F6A72D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2451 23.3223C30.3598 23.3223 28.9149 26.8107 30.9551 28.8508C31.5624 29.4582 31.9036 30.2819 31.9036 31.1409L31.9036 34.9351C31.9036 35.794 31.5624 36.6177 30.955 37.2251C28.9149 39.2653 30.3598 42.7536 33.245 42.7536L38.8081 42.7536L38.8081 55.6707C38.8081 56.329 39.3418 56.8626 40 56.8626C40.6583 56.8626 41.1919 56.329 41.1919 55.6707V42.7536L46.7549 42.7536C49.6402 42.7536 51.0851 39.2652 49.0449 37.2251C48.4376 36.6177 48.0964 35.794 48.0964 34.935L48.0964 31.1408C48.0964 30.2819 48.4376 29.4582 49.045 28.8508C51.0851 26.8107 49.6402 23.3223 46.755 23.3223L33.2451 23.3223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2881 87.2473C41.6952 89.4677 38.3943 89.4728 36.7947 87.2572L29.5783 77.2618C27.6684 74.6164 29.5587 70.9204 32.8214 70.9204L47.2079 70.9204C50.4651 70.9204 52.3567 74.6052 50.4582 77.2519L43.2881 87.2473Z",
    fill: "#F6A72D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9102 95.4469C39.2532 94.3911 40.7468 94.3911 41.0898 95.4469C41.2432 95.919 41.6832 96.2387 42.1796 96.2387C43.2897 96.2387 43.7512 97.6591 42.8532 98.3116C42.4515 98.6034 42.2835 99.1206 42.4369 99.5928C42.7799 100.649 41.5716 101.526 40.6735 100.874C40.2719 100.582 39.7281 100.582 39.3265 100.874C38.4284 101.526 37.2201 100.649 37.5631 99.5928C37.7165 99.1206 37.5485 98.6034 37.1468 98.3116C36.2488 97.6591 36.7103 96.2387 37.8204 96.2387C38.3168 96.2387 38.7568 95.919 38.9102 95.4469Z",
    fill: "#F6A72D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMarkerIcon);
export default __webpack_public_path__ + "static/media/pinMarkerIcon.de239e02d51b449aa6b150d14e4af28c.svg";
export { ForwardRef as ReactComponent };